import { SkeletonProvider } from './SkeletonProvider';
export class TicketSwapProvider extends SkeletonProvider { constructor() { super({ id: 'ticketswap', name: 'TicketSwap', authStrategy: 'partner_feed', documentationUrl: 'https://www.ticketswap.com/content/partners' }); } }
